import { cx } from '@linaria/atomic';
import { Icon } from './icon-component';
import { IconName } from './icon-constant';
import { IconContainerStyles } from './icon-container.styles';

/**
 * This component is to enforce best practices when using a icon.
 * Icons should not be modified directly - it will adapt to the parent container.
 */
export const ContainedIcon = ({
  as = 'span',
  iconName,
  className,
  background,
  color,
  size,
}: {
  as?: React.ElementType;
  iconName: IconName;
  className?: string;
  background?: string;
  color?: string;
  size?: number;
}) => {
  const Component = as;
  const actualSize = size ?? 16;
  return (
    <Component
      className={cx(IconContainerStyles.containedIconComponentStyle1, className)}
      style={{
        ...(background ? { background } : {}),
        ...(color ? { color } : {}),
        width: actualSize,
        height: actualSize,
      }}
    >
      <Icon name={iconName} className={IconContainerStyles.containedIconIconStyle2} />
    </Component>
  );
};
